import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // 페이지 이동 시 해시가 있는 경우 처리
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        // DOM이 완전히 로드된 후 스크롤
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [pathname, hash]); // pathname과 hash 변경 시 실행

  return null; // UI를 렌더링하지 않음
}

export default ScrollToHash;
